/**
 * General tag component.
 */

import type React from 'react';
import type { ReactElement, ReactNode } from 'react';

export function Tag({
  children,
  onClick,
}: {
  children: React.ReactNode;
  onClick?: (event) => void;
}): ReactElement {
  return (
    <button
      type="button"
      onClick={onClick}
      className="cursor-pointer bg-grey-light py-1 px-2 text-xs uppercase text-grey-darkest hover:bg-orange hover:text-white dark:bg-grey-dark dark:text-white dark:hover:bg-orange rounded-full"
    >
      {children}
    </button>
  );
}

const tagMap = {
  new: 'New',
  newFlavour: 'New Flavour',
  improvedFormula: 'Improved Flavour',
  limitedEdition: 'Limited Edition',
  limitedStock: 'Limited Stock',
  sellingFast: 'Selling Fast',
  vegan: 'Vegan',
  vegetarian: 'Vegetarian',
  hasta: 'HASTA',
  unsweetened: 'Unsweetened',
};

export function HighlightTag({
  tag,
  children,
}: {
  tag: keyof typeof tagMap;
  children: ReactNode;
}) {
  return (
    <span
      data-annotation={tag}
      className="absolute 
      -right-3 
      -top-2.5 
      rotate-10
      border
      border-solid
      border-white
      bg-(--bgColour)
      px-2
      py-px
      text-[0.75rem] text-white
      shadow-[1px_1px_2px_var(--bgColour)]
      data-[annotation=hasta]:[--bgColour:var(--color-blue-hasta)]
      data-[annotation=improvedFormula]:[--bgColour:var(--color-green-tag)] data-[annotation=newFlavour]:[--bgColour:var(--color-green-tag)]
      data-[annotation=new]:[--bgColour:var(--color-green-tag)]
      data-[annotation=limitedEdition]:[--bgColour:var(--color-orange)] data-[annotation=limitedStock]:[--bgColour:var(--color-orange)] data-[tag=sellingFast]:[--bgColour:var(--color-orange)]
      data-[annotation=unsweetened]:[--bgColour:var(--color-plant)] data-[annotation=vegan]:[--bgColour:var(--color-plant)] data-[tag=vegetarian]:[--bgColour:var(--color-plant)]"
    >
      {children}
    </span>
  );
}
